import { useQuery } from 'react-query';

import {
  GetWarriorAttackArgs,
  GetWarriorAttackResponse,
} from '~/../api/common.types';
import { api } from '~/client/api';

export const useGetWarriorAttack = ({
  data,
  enabled,
}: {
  data: GetWarriorAttackArgs;
  enabled: boolean;
}) => {
  return useQuery<GetWarriorAttackResponse | undefined, Error>(
    ['get-warrior-attack', data, data.warriorId],
    () => api.getWarriorAttack(data),
    {
      enabled,
    }
  );
};
